<template>
  <!-- 商品详情 -->
  <div id="productDetail" class="introduction" v-if="skuInfo">
    <!-- 活动资源位 -->
    <div
      class="detail resource"
      v-if="skuInfo.resourceIntro"
      v-html="skuInfo.resourceIntro"
      v-track="trackData.introduction({ sku_id: skuId, details_content: 1 })"
    ></div>
    <div id="introduction">
      <!-- 商品详情富文本 -->
      <div
        v-if="introHTML"
        id="tabContent1"
        class="detail tabContent"
        v-lazy-container="{ selector: 'img', loading: require('./images/loading.png') }"
        v-html="introHTML"
      ></div>

      <!-- 规格参数 -->
      <!-- <v-space v-if="isShowParameters"></v-space> -->
      <div
        id="tabContent2"
        class="box tabContent"
        v-if="isShowParameters"
        v-track="trackData.introduction({ sku_id: skuId, details_content: 2 })"
      >
        <div class="title">规格参数</div>
        <SpecRule @resetSpecRulePosition="resetSpecRulePosition" :skuInfo="skuInfo" />
      </div>

      <!-- 包装清单 -->
      <!-- <v-space v-if="isShowBoxingInfo"></v-space> -->
      <div id="tabContent3" class="box tabContent" v-if="isShowBoxingInfo" tabindex="0">
        <div class="title">包装清单</div>
        <div class="content" v-track="trackData.introduction({ sku_id: skuId, details_content: 3 })">
          <!-- 优先展示列表 其次展示图片 -->
          <div v-if="boxingInfo.type == 2" class="type-list">
            <div class="item" v-for="(v, key) in boxingInfo.boxingListVos" :key="key">
              <div class="img"><img v-lazy="v.boxingListIcon" alt="" /></div>
              <div class="word">{{ v.boxingListName }}</div>
            </div>
          </div>
          <img v-else v-lazy="boxingInfo.boxingImg" alt="包装图片信息" />
        </div>
      </div>
      <!-- 免责声明 -->
      <div class="box" v-if="spuInfo.concernContent || spuInfo.disclaimer">
        <!-- <v-space></v-space> -->
        <div
          class="res-title"
          v-track="trackData.introduction({ sku_id: skuId, details_content: 4 })"
          v-if="spuInfo.disclaimer"
        >
          免责声明
        </div>
        <ResponState />
      </div>
    </div>
  </div>
</template>

<script>
// 第三方包
import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'

// 组件
import SpecRule from './spec-rule/'
import VideoDetail from '../video/'
import ResponState from './spec-rule/respon-state'

// 方法
import { app } from '@/utils'
// 环境判断，QQ、官网App、微信、支付宝、农行app等环境判断
import clientEnv from '@/utils/clientEnv'
import { convertHTML } from '@/utils/common'
import trackData from './trackData'

const IMGREG_PNG = /<img[^>]+src="([^">]*?\.(png|jpg).*?)"[^>]*\/?>/g
const IMGREG_GIF = /<img[^>]+src="([^">]*?\.gif.*?)"[^>]*\/?>/g

export default {
  name: 'Introduction',
  components: { SpecRule, ResponState },
  data() {
    return {
      IO: null,
      clientEnv,
      videoRefs: [],
      hideVideo: clientEnv.isAndroid && clientEnv.androidLevel < 4.5,
      trackData
    }
  },
  computed: {
    ...mapState('detailv3', ['skuInfo', 'spuInfo']),
    ...mapGetters('detailv3', ['isYX']),
    // 对富文本进行过滤筛选
    introHTML() {
      let intro = this.skuInfo.intro
      if (!intro) return
      intro = intro.replace(/<img\s+[^>]*src="([^"]*)"[^>]*>/g, '<img src="$1" alt="商品信息介绍">')
      if (this.isYX) {
        // 严选 gif 图片不适用 webp ，与其他图片一致
        intro = intro.replace(IMGREG_GIF, '<img src="$1" class="webp__disabled">')
        // 严选商品图片特殊处理， 使用严选的图床， 并进行质量扩展
        intro = intro.replace(
          IMGREG_PNG,
          '<img src="$1?imageView&type=webp&thumbnail=1200x0&enlarge=1" class="webp__disabled">'
        )
      } else {
        // 常规商品 gif 宽度 auto ，黑底
        intro = intro.replace(IMGREG_GIF, '<p class="dark"><img src="$1" class="webp__disabled"></p>')
      }
      // 处理 video
      intro = intro.replace(/<video/g, '<p class="dark"><video style="display:none;"')
      intro = intro.replace(/<\/video>/g, '</video><p class="ed-video-wrap"></p></p>')
      // 图文详情不支持音频
      intro = intro.replace(/<audio[\s\S]*?<\/audio>/gm, '')
      // 清除零宽字符
      intro = intro.replace(/\u200D/g, '')
      return convertHTML(intro)
    },
    intro() {
      if (this.skuInfo?.intro) return convertHTML(this.skuInfo.intro)
      else return ''
    },
    skuId() {
      return this.skuInfo?.commoditySkuBaseInfo?.skuId
    },
    boxingInfo() {
      return this.skuInfo?.boxingInfo
    },
    isShowBoxingInfo() {
      return this.skuInfo?.boxingInfo?.boxingListVos || this.skuInfo?.boxingInfo?.boxingImg
    },
    isShowParameters() {
      return this.skuInfo?.parameters?.length
    }
  },
  watch: {
    skuInfo: {
      immediate: true,
      handler(html) {
        setTimeout(this.observeVideo, 0)
        if (html) {
          this.interceptALabel()
        }
      }
    }
  },
  methods: {
    initObserver() {
      let self = this
      // 如果有视频实例存在，先移除
      this.videoRefs.length &&
        this.videoRefs.forEach(item => {
          let videoItem = this.$refs[item]
          videoItem && videoItem.vm.$destroy()
        })
      let VVideoDetail = Vue.extend(VideoDetail)
      let videoOptions = this.infoVideoOptions()
      this.videoRefs = []
      videoOptions.length &&
        videoOptions.forEach((op, idx) => {
          let videoInstance = new VVideoDetail()
          videoInstance.infoVideoOptions = op
          videoInstance.playerId = idx
          videoInstance.code = idx
          videoInstance.vm = videoInstance.$mount()
          videoInstance.hasRate = true
          videoInstance.endedCallback = $el => {
            // 播放完一次后下次不再自动播放
            let $video = $el.querySelector('.video-container')
            if ($el && $video) {
              $video.setAttribute('loaded', true)
            }
          }
          videoInstance.beforePlayCallback = () => {
            // 暂停所有视频
            this.videoRefs.length &&
              this.videoRefs.forEach(item => {
                let videoItem = this.$refs[item]
                videoItem && videoItem.isShowVideo && videoItem.pauseVideo()
              })
          }
          // 视频从最大化恢复到原始状态时，官网app和浏览器有一次屏幕对焦切换，导致滚动条和swiper错位，因此手动复位
          videoInstance.exitFullscreenCallback = $el => {
            setTimeout(() => {
              // 视频回到可视区
              $el.scrollIntoView()
              // swiper回到初始位置
              let $swipers = document.querySelectorAll('.parts-similar .swiper-wrapper')
              $swipers &&
                $swipers.length &&
                $swipers.forEach($swiper => {
                  let transform = $swiper.style.transform
                  if (transform) {
                    let translate3d = /translate3d\(\s*(-?[\d\.]+)px[^\)]*?\)/gi.exec(transform)
                    if (translate3d && translate3d[1] != 0) {
                      $swiper.style.setProperty('transform', 'translate3d(0px, 0px, 0px)')
                    }
                  }
                })
            }, 1000)
          }
          let videoEl = document.getElementsByClassName('ed-video-wrap')
          if (videoEl && videoEl[idx]) {
            videoEl[idx].innerHTML = ''
            videoEl[idx].appendChild(videoInstance.vm.$el)
          }
          this.$refs['videoPlayer_' + idx] = videoInstance
          this.videoRefs.push('videoPlayer_' + idx)
        })
      // 创建视口监听器
      this.IO = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            let currentVideo = self.$refs['videoPlayer_' + entry.target.getAttribute('code')]
            if (entry.intersectionRatio >= 1) {
            } else if (entry.intersectionRatio <= 0) {
              // 如果vide完全移出视口时停止播放
              if (currentVideo && !currentVideo.isFullscreen()) {
                currentVideo.pauseVideo()
              }
            }
          })
        },
        {
          rootMargin: '0% 0% -9% 0%',
          threshold: [0, 1]
        }
      )
    },
    observeVideo() {
      // 安卓4.4版本之前由于官网app不支持视频播放，因此隐藏视频
      if (this.hideVideo) return
      // 销毁原来的监听器
      if (this.IO) {
        this.IO.disconnect()
        this.IO = null
      }
      // 创建新的监听器
      this.initObserver()
      // 监听video元素
      const videos = this.$el.querySelectorAll('.video-container')
      for (let video of videos) {
        this.IO.observe(video)
      }
    },
    infoVideoOptions() {
      let videoSource = []
      try {
        const str = this.intro
        if (str) {
          const reg = /<video.*?<\/video>/gi
          const arr = str.match(reg)
          if (Array.isArray(arr)) {
            arr.forEach(videoStr => {
              let videoReg = /<source [^>]*src=['"]([^'"]+)[^>]*>/gi
              let sourceArr = videoStr.match(videoReg)
              if (Array.isArray(sourceArr)) {
                let filterArr = sourceArr.filter(item => /.mp4/.test(item))
                let current = filterArr[0]
                const src = current.match(/src=".*?"/gi)
                const type = current.match(/type=".*"/gi)
                let videoSrc = src[0].split('=')[1].split('"')[1]
                let videoType = type[0].split('=')[1].split('"')[1]
                let coverImg = videoStr.match(/poster=".*?"/gi)
                let videoPoster = coverImg ? coverImg[0].split('=')[1].split('"')[1] : ''
                videoSource.push({
                  videoSrc: videoSrc,
                  videoPoster: videoPoster || this.skuInfo.imageInfos[0].bigPic,
                  videoTime: '23',
                  videoType: videoType,
                  preload: 'auto',
                  isShowVideoDetail: true
                })
              }
            })
          }
        }
      } catch (err) {
        console.log('err', err)
      }
      return videoSource
    },
    resetSpecRulePosition() {
      this.$emit('resetSpecRulePosition')
    },
    interceptALabel() {
      this.$nextTick(() => {
        let doc = document.getElementById('productDetail')
        doc.addEventListener('click', this.replaceJump)
      })
    },
    replaceJump(event) {
      // 判断元素路径是否存在a标签
      // 苹果不存在path属性
      let target = null
      if (event.path) {
        // es6写法
        target = event.path.find(el => el.nodeName?.toLocaleLowerCase() === 'a')
        // es5写法
        // for (let i = 0; i < event.path.length; i++) {
        //   if (event.path[i].nodeName.toLocaleLowerCase() === 'a') {
        //     target = event.path[i]
        //     break
        //   }
        // }
      } else {
        // 对于苹果浏览器，需要手动遍历父元素找到a标签
        let node = event.target
        while (node.parentNode !== null) {
          if (node.nodeName?.toLocaleLowerCase() === 'a') {
            target = node
            break
          } else {
            node = node.parentNode
          }
        }
      }
      if (target) {
        // 阻止事件冒泡
        event.stopPropagation()
        // 阻止默认事件
        if (event.preventDefault) {
          event.preventDefault()
        } else {
          window.event.returnValue = true
        }
        let url = target.getAttribute('href')
        app.openNewWebview({
          url: url
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
